var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9116 6.47702L20.5991 0.119443C20.2155 -0.0397754 19.7844 -0.0398535 19.4009 0.119443L4.08836 6.47702C3.50516 6.71921 3.125 7.28858 3.125 7.92007V15.6486C3.125 26.2902 9.55695 35.8626 19.4095 39.8841C19.788 40.0386 20.212 40.0386 20.5905 39.8841C30.4429 35.8627 36.875 26.2903 36.875 15.6486V7.92007C36.875 7.28858 36.4949 6.71921 35.9116 6.47702ZM33.75 15.6486C33.75 24.6951 28.4375 33.023 20 36.7403C11.788 33.1223 6.25 24.9402 6.25 15.6486V8.96319L20 3.25429L33.75 8.96319V15.6486ZM18.273 20.9153L24.9889 14.1994C25.5991 13.5893 26.5884 13.5892 27.1986 14.1994C27.8088 14.8097 27.8088 15.799 27.1985 16.4091L19.3778 24.2298C18.7675 24.8401 17.7782 24.8399 17.1681 24.2298L12.8014 19.8631C12.1912 19.2529 12.1912 18.2636 12.8014 17.6534C13.4116 17.0433 14.4009 17.0432 15.0111 17.6534L18.273 20.9153Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.0ca785ec1c8cf0eb9a1804147d50c666.svg";
export { ForwardRef as ReactComponent };